import React, { useMemo, useState } from "react";
import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { AccrualMatchViewCtx } from "@components/accounting/transactionMatch/accrualMatchView.context";
import { AccrualMatchColumn } from "@components/accounting/transactionMatch/types";

interface Props {
    children: React.ReactNode;
}

const accrualMatchAuditView: View = {
    type: ViewType.TRANSACTION,
    columns: [
        { id: AccrualMatchColumn.DATE },
        { id: AccrualMatchColumn.TYPE },
        { id: AccrualMatchColumn.COUNTERPARTY },
        { id: AccrualMatchColumn.DESCRIPTION },
        { id: AccrualMatchColumn.ACCOUNT },
        { id: AccrualMatchColumn.CLASS },
        { id: AccrualMatchColumn.AMOUNT },
        { id: AccrualMatchColumn.ENTITY },
    ],
    filters: {},
    options: { density: ViewDensity.MD },
};

export const AccrualMatchAuditViewProvider: React.FC<Props> = ({
    children,
}) => {
    const [tableView, setTableView] = useState<View>(accrualMatchAuditView);
    const value = useMemo(() => ({ tableView, setTableView }), [tableView]);
    return (
        <AccrualMatchViewCtx.Provider value={value}>
            {children}
        </AccrualMatchViewCtx.Provider>
    );
};
